var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 78,
    viewBox: "0 0 77 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6674 41.316L30.5671 53.1385L58.1988 25.6861",
    stroke: "#186174"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.4332,
    cy: 39.4123,
    r: 37.9333,
    stroke: "#186174"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDone);
export default __webpack_public_path__ + "static/media/check_done.35b5968142d9d5effebee1519d15f186.svg";
export { ForwardRef as ReactComponent };